import React, { useState, memo } from 'react';
import { useSlate } from 'slate-react';
import classnames from 'classnames';

import Icon from 'components/Misc/Icon';
import Browser from 'components/Browser';

const Image = memo(({ path, folder }) => {
	// Get current editor
	const editor = useSlate();

	// Use state for browser visibility
	const [browser, setBrowser] = useState(false);

	// Cache link's data
	const [selection, setSelection] = useState(null);

	// Check if current align is active
	const isActive = editor.isElementActive('image');

	// Check if formula is disabled
	const isDisabled = editor.isMediaDisabled();

	// Generate classnames
	const cls = classnames(
		isActive && 'bg-neutral-100 dark:bg-neutral-700',
		isDisabled
			? 'text-neutral-400 dark:text-neutral-700'
			: 'text-neutral-800 dark:text-white',
		'w-9 h-9 leading-9 rounded-lg text-xl text-center cursor-pointer transition-colors'
	);

	// Show browser
	const showBrowser = () => {
		// Update modal visibility
		setBrowser(true);

		// Cache editor's selection
		setSelection(editor?.selection);
	};

	// Hide browser - executed from browser
	const hideBrowser = () => {
		// Update modal visibility
		setBrowser(false);

		// Clean up editor's selection
		setSelection(null);
	};

	// Handles file selection - executed from browser
	const handleSelect = selected => {
		// Insert selected image
		editor.insertMedia('image', selected, selection);

		// Hide browser
		hideBrowser();
	};

	return (
		<>
			<Icon
				icon="photo"
				className={cls}
				onClick={showBrowser}
				disabled={isDisabled}
			/>

			<Browser
				path={path}
				folder={folder}
				category="image"
				visible={browser}
				onClose={hideBrowser}
				onSelect={handleSelect}
			/>
		</>
	);
});

export default Image;
